import globalStyle from '../../styles/common.module.css'
import style from './footer.module.css'

export function Footer() {
  return (
    <footer className={[style.footer, globalStyle.fontGray2].join(' ')}>
      <div className={style.section}>
        <p className={[globalStyle.bodyXS, globalStyle.fontGray1].join(' ')}> &copy; {(new Date()).getFullYear()} Language, Please </p>
        <p className={globalStyle.bodyXS}>
          <a target='_blank' rel='noopener noreferrer' href="http://languageplease.org/privacy-policy"> Privacy Policy </a>
        </p>
        <p className={globalStyle.bodyXS}>
          <a target='_blank' rel='noopener noreferrer' href="http://languageplease.org/terms-of-use"> Terms of Use </a>
        </p>
      </div>

      <div className={style.section}>
        <p className={globalStyle.bodyXS}>
          <a className={[globalStyle.iconText, style.neverEndingChangesThreeMonthsLate].join(' ')} target='_blank' rel='noopener noreferrer' href="http://languageplease.org"> 
            <img className={style.logo} src='assets/icons/lp-logo.svg' alt='Language Please icon'/>
            Language, Please
          </a>
        </p>
      </div>
    </footer>
  );
}
